module.exports = __webpack_public_path__ + "img/feature-table.82cdd638.png";